import * as Icons from '@ant-design/icons';
import { Popconfirm, Space } from "antd"
import { FC } from 'react';

interface Prop {
  id: string,
  onEdit?: (id: string) => void,
  onDelete: (id: string) => void,
  children?: JSX.Element[] | JSX.Element
}

const Actions: FC<Prop> = ({ id, onEdit, onDelete, children }) => {
  return (
    <Space>
      {children}
      {onEdit &&
        <Icons.EditTwoTone
          style={{ fontSize: "18px" }}
          onClick={() => { onEdit(id) }} >
        </Icons.EditTwoTone>}
      <Popconfirm
        title="آیا از حذف این آیتم اطمینان دارید؟"
        onConfirm={() => { onDelete(id) }}
        okText="بله"
        cancelText="خیر"
      >
        <Icons.DeleteTwoTone style={{ fontSize: "18px" }} />
      </Popconfirm>
    </Space>
  )
}

export default Actions
